<aml-maintenance-warning
  [message]="maintenanceMessage()"
  [maintenanceNoticeVisibilityPreference]="showMaintenanceNotice()"
  (whenCloseMaintenanceNotice)="onMaintenanceWarningClose()"
/>

<nz-layout class="app-layout">
  <aad-sidebar />
  <nz-layout>
    <nz-content>
      <aad-impersonation-banner />
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
    <aad-footer />
  </nz-layout>
</nz-layout>

